module.exports = __webpack_public_path__ + "static/img/qz_banner.16f018d.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/qz_banner.png
// module id = b0Nv
// module chunks = 2